<template >





 <div  class="container-flight margin_container_hf">

     <div v-if="responseId<=1 || responseId===17 || responseId ==4001"   class="wrapper">
  <div class="landing-page">
    <div style="text-align:center;" class="icon__download">
        <img style="    width: 64%;
    margin-bottom: 22px; height: auto;" src="../../../public/img/tour_error.png" alt="">
			</div>
    
    <h1 > {{responseLabel}}</h1>

    <p v-if="responseId!==17"> با پشتیبانی تماس بگیرید</p>
    <button @click="gotoHome()" class="button_error">بازگشت به صفحه اصلی</button>
  </div>
</div>

     <div v-else>
  <TicketAction :tickets="ticketActionModel" />
   <div style="margin-top: 20px;" class="box_style_2">
      <div class="invoice-header">
                <div class="row">
                  <div class="col-md-8">
                    <h1 style="font-size: 25px; color: #08446a;margin-bottom: 3px;"> <small>{{ tickets[0].hotelTitle }}</small></h1>
                    <h4 style="font-size: 16px;">PNR: {{ tickets[0].pnr }} |HOTEL RSV-NO: {{ tickets[0].hotelReserveNumber }} | Date: {{ tickets[0].shamsiDate }}</h4>
                     <h4 style="font-size: 16px;       display: inline-flex;">وضعیت پرداخت: <div style="color:green;margin-left: 5px;" v-if="tickets[0].isPaid"> موفق</div> <div style="color:red;margin-left: 5px;" v-else>ناموفق</div>  | نوع پرداخت : <div style="color: #0a6c9f;" v-if="tickets[0].paymentType==='Cash'"> آنلاین</div> <div style="color: #a606b9;" v-else>اعتباری</div></h4>
                  </div>
                  <div class="col-md-4">
                    <div style="font-size: 16px;
    line-height: 27px;" class="media">
                    
                      <ul class="media-body list-unstyled">
                         <li>واچر سیستم: {{ tickets[0].voucherNumber }}</li>
                        <li>تاریخ ورود: {{ tickets[0].shamsiDepartureDate }}</li>
                        <li>
                  تاریخ خروج: {{ tickets[0].shamsiReturnDate }}</li>
                        <!-- <li>آدرس : {{tickets[0].hotel.address}}</li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

    </div>

    <div id="flight-ticket">
      <div>
        <h3 style="color: #087ab5">
          <i class="icon-flight filter-icon"></i>
          تیکت پرواز
        </h3>
      </div>
      <div class="box_style_2">
        <div id="flight">
         <div style="display: flex">
            <div class="package-time">
              <i
                style="font-size: 16px; color: #928c8c"
                class="icon-reply-1"
              ></i>
              <label
                >تاریخ پرواز رفت:
                <span>{{ tickets[0].shamsiDepartureDate }}</span></label
              >
              <label
                >ساعت : <span>{{ tickets[0].departuretimeStr }}</span></label
              >
            </div>
            <div style=" left: 18px" class="package-time">
              <i
                style="font-size: 16px; color: #928c8c"
                class="icon-forward-1 filter-icon"
              ></i>
              <label
                >تاریخ پرواز برگشت:
                <span>{{ tickets[0].shamsiReturnDate }}</span></label
              >
              <label
                >ساعت : <span>{{ tickets[0].returntimeStr }}</span></label
              >
            </div>
          </div>
          <div style="margin-top: 14px" class="cart-section">
            <table class="rwd-table">
              <thead>
                <tr class="rwd-table-header">
                  <th>هواپیمایی</th>
                  <th>شماره پرواز</th>
                  <th>مبدا</th>
                  <th>مقصد</th>

                  <th>نام و نام خانوادگی</th>
                  <th>کدملی</th>
                  <th>شماره بلیط</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ticket, index) in flightTickets" :key="index">
                  <td data-th="هواپیمایی">
                    <img
                      class="mb8 airlines_logo"
                      :src="getAirLineLogoUrl(ticket.airlineId)"
                    />
                  </td>
                  <td data-th="شماره پرواز">
                    {{ ticket.flightNumber }}
                  </td>
                  <td data-th="مبدا">
                    {{ ticket.originLocation }}
                  </td>
                  <td data-th="مقصد">
                    {{ ticket.destinationLocation }}
                  </td>

                  <td data-th="نام و نام خانوادگی">
                    {{ ticket.passengerName }} &nbsp;
                    {{ ticket.passengerLastName }}
                  </td >
                  <td data-th="کدملی">
                    {{ ticket.pasportId }}
                  </td>
                  <td data-th="شماره بلیط">
                    {{ ticket.ticketNumber }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="cart-options clearfix">
              <div class="float-left">
                <!-- <div class="apply-coupon">
							<div class="form-group">
								<input type="text" name="coupon-code" value="" placeholder="Your Coupon Code" class="form-control">
							</div>
							<div class="form-group">
								<button type="button" class="btn_cart_outine">Apply Coupon</button>
							</div>
						</div> -->
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>

    <div id="hotel-ticket">
      <div>
        <h3 style="color: #087ab5">
          <i class="icon-warehouse filter-icon"></i>
          واچر هتل
        </h3>
      </div>
      <div class="box_style_2">
        <div id="hotel">
          <div class="voucher_detail">
            <div id="hotel">
              <label>{{ tickets[0].hotelTitle }}</label>
              <label style="position: absolute; left: 25px"
                >شماره واچر : {{ tickets[0].voucherNumber }}</label
              >
            </div>
            <div id="time">
              <label>تاریخ ورود: {{ tickets[0].shamsiDepartureDate }}</label>
              <label style="margin-right: 6%"
                >تاریخ خروج: {{ tickets[0].shamsiReturnDate }}</label
              >
            </div>

            <div class="room_details">
              <table class="rwd-table">
                <tbody>
                  <tr class="rwd-table-header">
                    <th>اتاق</th>
                    <!-- <td>تعداد</td> -->
                    <th>بزرگسال</th>
                    <th>کودک</th>
                    <th>تخت اضافه</th>
                  </tr>
                  <tr v-for="(room, index) in roomDetails" :key="index">
                    <td data-th="اتاق">{{room.hotelRoomTypeTitle}}</td>
                    <!-- <td>{{ room.roomPax }}</td> -->
                    <td data-th="بزرگسال">{{ room.roomAdult }}</td>
                    <td data-th="کودک">{{ room.roomChild }}</td>
                    <td data-th="تخت اضافه"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            style=" margin: auto; margin: 20px auto auto auto"
            class="cart-section"
          >
            <h4 style="color: #208746">
              <i style="font-size: 24px" class="icon-users-1"></i>مشخصات مسافرین
            </h4>
            <table class="rwd-table">
              <thead>
                <tr class="rwd-table-header">
                  <th>نام</th>
                  <th>کدملی</th>
                  <th>تاریخ تولد</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(passenger, index) in passengers" :key="index">
                  <td data-th="نام">
                    {{ passenger.passengerName }} &nbsp;
                    {{ passenger.passengerLastName }}
                  </td>
                  <td data-th="کدملی">
                    {{ passenger.pasportId }}
                  </td>
                  <td data-th="تاریخ تولد">{{ passenger.birthDateShamsi }}</td>
                </tr>
              </tbody>
            </table>
<div style="direction: rtl;" class="customer_request">
<strong style="color: #208746;margin-left: 5px;">درخواست مسافر:</strong>
<span>{{tickets[0].customerRequest}}</span>
</div>
            <div class="cart-options clearfix">
              <div class="float-left">
                <!-- <div class="apply-coupon">
							<div class="form-group">
								<input type="text" name="coupon-code" value="" placeholder="Your Coupon Code" class="form-control">
							</div>
							<div class="form-group">
								<button type="button" class="btn_cart_outine">Apply Coupon</button>
							</div>
						</div> -->
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
     </div>
    
  </div>

 
</template>


<script>
import $ from "jquery";

import Store from "./store/index";
import TicketAction from "../../components/tour/TicketAction";
require("linqjs");

export default {
  store: Store,

  components: { TicketAction },
  data() {
    return {
        responseId:Number,
        responseLabel:'خطا در رزرو',
      params: {},
      tickets: [],
      roomDetails: [],
      passengers: [],
      flightTickets:[],
      ticketActionModel: {},
    };
  },
  created() {
    this.params = this.$route.query;
    this.responseId =Number(this.params.id) ;

    if (this.responseId <1) {
        if (this.responseId === -3) {
    this.responseLabel = "خطا در پرداخت"
}else {
    this.responseLabel = "خطا در رزرو"

}
    }

     if (this.responseId === 17) {
       this.responseLabel = "انصراف از پرداخت";
    }

    this.getTicket(this.params.id);
  },
  computed: {},
  methods: {
        gotoHome() {
      if (this.$route.name != "main home") this.$router.push("/");
    },
    getAirLineLogoUrl(name) {
      return "../img/airlines/" + name + ".png";
    },
    async getTicket(reserveNumber) {
      var ticketReq = {
        reserveNumber: reserveNumber,
         sourceProfileId: localStorage.getItem("SourceProfileId")
      };
  

      var res = await this.$store.dispatch("Book/GetTicket", ticketReq);
      if (res) {
        if (res != null) {
          if (res.errorCode === 4001) {
            this.responseId = 4001;
            this.responseLabel = "شماره رزرو معتبر نمی باشد";
          }
          this.tickets = res.ticketModels;
          this.roomDetails = res.ticketModels.reduce(
            (results, item) =>
              results.find((i) => i.roomDetailId === item.roomDetailId)
                ? results
                : [...results, item],
            []
          );

          this.passengers = res.ticketModels.reduce(
            (results, item) =>
              results.find((i) => i.pasportId === item.pasportId)
                ? results
                : [...results, item],
            []
          );

          this.flightTickets =  res.ticketModels.reduce(
            (results, item) =>
              results.find((i) => i.originIsoCode === item.originIsoCode && i.destinationIsoCode === item.destinationIsoCode && i.pasportId === item.pasportId)
                ? results
                : [...results, item],
            []
          );
          this.ticketActionModel= {
              tickets: this.tickets,
              roomDetails: this.roomDetails,
              passengers: this.passengers,
              flightTickets: this.flightTickets,
              hotelDetail: res.hotelDetail
          }
          console.log('this.ticketActionModel',this.ticketActionModel);
        } else {
          console.log("Failed");
        }
      }
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">

.rwd-table {
  width: 100%;
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
  
}

.rwd-table-header {
  border-top: none;
background: #ffffff !important;
    color: #0c3a50;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
 background-color: #f7f7f7;
}
 .rwd-table tr th {
         text-align: right;
 }
  .rwd-table tr td {
          text-align: right;
 }


.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table {
  color: #333;
  border-radius: .4em;
  overflow: hidden;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    padding: 1em !important;
  }
}

#action a {
  width: 140px;
}
.voucher_detail {
  display: grid;
  text-align: initial;
  font-size: 15px;
}

.voucher_detail time {
  display: flex;
}
.voucher_detail label {
  text-align: initial;
}
.package-time {
  text-align: initial;
}
.package-time label {
  margin-left: 10px;
  font-size: 15px;
}
.package-time label strong {
  color: rgb(73, 72, 72);
}
.table tbody tr td {
  text-align: initial;
}
.airlines_logo {
  width: 30px;
  height: 30px;
}
.room_details {
  width: 90% !important;
  margin: 25px auto auto auto;
}

.room_details table tbody tr td {
  text-align: center;
}


.wrapper {
  max-width: 960px;
  width: 100%; 
  margin: 30px auto;
  transform: scale(0.8);
}
.landing-page {
  max-width: 960px;
  height: 490px;
  margin: 0;
  box-shadow: 0px 0px 8px 1px #ccc;
  background: #fafafa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
svg {
  width: 50%;
  max-height: 225px;
  height: auto;
  margin: 0 0 15px;
}
h1 {
  font-size: 30px;
  margin: 0;
}
p {
  font-size: 16px;
  width: 35%; 
  margin: 16px auto 24px;
  text-align: center;
}
.button_error {
  border-radius: 50px;
  padding: 8px 24px;
  font-size: 16px;
  cursor: pointer;
  background: #177bff;
  color: #fff;
  border: none;
  box-shadow: 0 4px 8px 0 #ccc;
      width: 200px;
}

.customer_request{
  margin-top: 50px;
  text-align: initial;
    font-size: 14px;
    padding: 15px 5px 15px 5px;
    background: #f5faf7;
}

.invoice-header{
    padding:25px 25px 15px;
    h1{
      margin:0
    }
    .media{
      .media-body{
        font-size:.9em;
        margin:0;
      }
    }
  }

</style>